import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { SpecieFamilyService } from '../proxy/planning/controllers/specie-family.service';
import { FaunaClassService } from '../proxy/planning/controllers/fauna-class.service';

FieldBuilder.setNamespace('Planning');

export const FAUNASPECIE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('commonName', 'Entity.FaunaSpecie.CommonName')
    .required()
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('scientificName', 'Entity.FaunaSpecie.ScientificName')
    .required()
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.FaunaSpecie.Code')
    .required()
    .maxLength(10)
    .build(),
  FieldBuilder
    .text('iucn', 'Entity.FaunaSpecie.IUCN')
    .maxLength(10)
    .build(),
  FieldBuilder
    .checkbox('snapPriority', 'Entity.FaunaSpecie.SNAPPriority')
    .build(),
  FieldBuilder
    .checkbox('snapThreat', 'Entity.FaunaSpecie.SNAPThreat')
    .build(),
  FieldBuilder
    .checkbox('forestryThreat', 'Entity.FaunaSpecie.ForestryThreat')
    .build(),
  FieldBuilder
    .checkbox('cites', 'Entity.FaunaSpecie.Cites')
    .build(),
  FieldBuilder.foreignKey(
    'specieFamilyId',
    'Entity.SpecieFamily',
    SpecieFamilyService
  )
    .displayFromNested('specieFamily.name')
    .sortBy('specieFamily.name')
    .build(),
  FieldBuilder.foreignKey(
    'faunaClassId',
    'Entity.FaunaClass',
    FaunaClassService
  )
    .required()
    .displayFromNested('class.name')
    .sortBy('class.name')
    .build(),
];

export const FAUNASPECIE_CONFIG = {
  entityName: 'FaunaSpecie',
  localizationKey: 'Planning::Entity.FaunaSpecie',
  fields: FAUNASPECIE_FIELDS,
  permission: 'PlanningEnvironment.FaunaSpecies',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Environment + MENU_NAME_SUFFIX,
};
